import { entityValue } from 'app/infrastructure/store/entity';
import { columnName, tableName } from 'app/area/case/case-data-model';
import { Entity } from 'app/types-shared';
import maxBy from 'lodash/maxby';
import minBy from 'lodash/minby';
import isNumber from 'lodash/isnumber';

export const sequence = (connection: Entity) => {
  return Number(entityValue(connection, columnName[tableName.connectedCases].connectedSequence));
};

export const maxSequenceEntity = (connections: Entity[]) => {
  return maxBy(connections, c => sequence(c));
};

export const minSequenceEntity = (connections: Entity[]) => {
  return minBy(connections, c => sequence(c));
};

export const nextSequenceValue = (maxSequence: number) => {
  return (maxSequence && isNumber(maxSequence)) ? maxSequence + 1 : 1;
};

export const updateSequence = (
  entities: Entity[],
  fromIndex: number,
  steps: number,
  direction: 'up' | 'down'
): Entity[] => {
  const cloned = [...entities];
  let targetIndex = fromIndex;

  const step = direction === 'up' ? -1 : 1;
  const absSteps = Math.abs(steps);

  for (let i = 0; i < absSteps; i++) {
    const nextIndex = targetIndex + step;
    if (nextIndex < 0 || nextIndex >= cloned.length) {
      break;
    }

    [cloned[targetIndex], cloned[nextIndex]] =
      [cloned[nextIndex], cloned[targetIndex]];

    targetIndex = nextIndex;
  }
  return cloned;
};
